import { useTranslation } from 'react-i18next';

const steps = [
  { key: 'step1', num: '01', icon: 'ri-search-line' },
  { key: 'step2', num: '02', icon: 'ri-check-double-line' },
  { key: 'step3', num: '03', icon: 'ri-bar-chart-box-line' },
];

export default function HowItWorks() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-20 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-warm-900 mb-3">
            {t('howItWorks.h2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {steps.map((step, index) => (
            <div key={step.key} className="relative text-center">
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-8 left-[60%] w-[80%] h-px bg-warm-200" />
              )}
              <div className="w-16 h-16 mx-auto rounded-full bg-brand-50 border border-brand-200 flex items-center justify-center mb-4">
                <i className={`${step.icon} text-brand-600 text-xl`} />
              </div>
              <span className="inline-block text-xs font-bold text-brand-600 mb-2">
                {step.num}
              </span>
              <h3 className="font-heading text-lg font-semibold text-warm-900 mb-2">
                {t(`howItWorks.${step.key}`)}
              </h3>
              <p className="text-sm text-warm-500 leading-relaxed">
                {t(`howItWorks.${step.key}Desc`)}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-brand-600 text-white font-medium rounded-full hover:bg-brand-700 transition-colors"
          >
            {t('howItWorks.cta')}
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}